import { FC } from "react";
import { PiMusicNotesFill } from "react-icons/pi";
import { useIsMobile } from "~/hook/use-mobile";
import { cn } from "~/lib/utils";
import { COLORS } from "~/utils/constant";

type Props = {
  isVisible: boolean;
  className?: string;
};

const AudioIcon: FC<Props> = ({ isVisible = false, className }) => {
  const isMobile = useIsMobile();
  return (
    <div
      className={cn("flex items-center justify-center px-1 py-0.5 rounded-lg bg-slate-800/70", className, {
        hidden: !isVisible,
        visible: isVisible,
      })}
    >
      <PiMusicNotesFill size={isMobile ? 12 : 15} color={COLORS.white} className="transition-transform duration-300" />
    </div>
  );
};

export default AudioIcon;
